/**
 * Header Context
 * Allows pages to inject content into the left side of the header (page title/subtitle)
 */

import { createContext, useContext, useState, type ReactNode } from 'react'

interface HeaderContextValue {
  headerLeft: ReactNode
  setHeaderLeft: (content: ReactNode) => void
}

const HeaderContext = createContext<HeaderContextValue | null>(null)

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [headerLeft, setHeaderLeft] = useState<ReactNode>(null)

  return (
    <HeaderContext.Provider value={{ headerLeft, setHeaderLeft }}>
      {children}
    </HeaderContext.Provider>
  )
}

function useHeaderContext() {
  const context = useContext(HeaderContext)
  if (!context) {
    throw new Error('useHeaderContext must be used within a HeaderProvider')
  }
  return context
}

export function useSetHeaderLeft() {
  const { setHeaderLeft } = useHeaderContext()
  return setHeaderLeft
}

export function useHeaderLeftContent() {
  const { headerLeft } = useHeaderContext()
  return headerLeft
}
